import { useState } from 'react'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { CommentMessage } from '@root/entities/comment/ui'
import { PaperPlane2Icon } from '@root/shared/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

type CommentsThreadMessageProps = {
  open: boolean
  isLoading: boolean
  imageAttachment?: string
  onMessageSend: (text: string) => void
  onMessageShow: () => void
  onClose: () => void
  onImageAttachedChange?: (image: string | undefined) => void
} & ClassNameProps

export const CommentsThreadMessage = ({
  open,
  isLoading,
  onMessageSend,
  onMessageShow,
  onClose,
  imageAttachment,
  onImageAttachedChange,
  className,
}: CommentsThreadMessageProps) => {
  const [text, setText] = useState<string>('')

  if (!open) {
    return (
      <Root className={className}>
        <Action>
          <ButtonOpen
            color="primary"
            onClick={onMessageShow}
            iconLeft={<PaperPlane2Icon />}
          />
        </Action>
      </Root>
    )
  }

  return (
    <Root className={className}>
      {/*
        Deluge only let its "Hyped" referral tier post, and nothing here ever
        sets that status — so the gate closed on everybody and the box could
        not be typed in at all. Getting into this terminal is already the
        gate: it is invite-only, so whoever is signed in may write.
      */}
      <CommentMessage
        withClose
        isLoading={isLoading}
        text={text}
        imageAttached={imageAttachment}
        onChange={(value) => setText(value)}
        onMessageSend={onMessageSend}
        onClose={onClose}
        onImageAttachedChange={onImageAttachedChange}
      />
    </Root>
  )
}

const Root = styled.div``

const Action = styled.div`
  height: 42px;
  place-self: end;
  display: grid;
  align-items: center;
`

const ButtonOpen = styled(Button)`
  color: var(--text-11);
  border: 1px solid var(--backgroundA-4);

  padding: 5px;
  place-self: end;
  align-self: center;

  &:hover:not([disabled]) {
    color: var(--text-12);
  }
`
